export { default as TableEssay } from './TableEssay'
